export { CollectionContentCard } from './CollectionContentCard'
